'use strict'

import { apiInstance, legacyV2 } from './index'
import { mapArgs } from 'utils/functions'

const report = {
  getRides (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/taxijobs`,
      params
    })
  },

  getCostCenters (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/costCenter`,
      params
    })
  },

  getEmployee (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/employee`,
      params
    })
  },

  getChart (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/chart`,
      params
    })
  },

  exportReportRides (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/taxijobs/export/validate`,
      params
    })
  },

  exportReportCostCenters (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/costCenter/export/validate`,
      params
    })
  },

  exportReportEmployee (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/employee/export/validate`,
      params
    })
  },

  exportValidate (args) {
    const { companyId, search, type } = args
    const params = { companyId, search }
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/${type}/export`,
      params
    })
  },

  exportConsolidatedReport (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/report/taxijobs/schedule`,
      data
    })
  },

  /** 轮询下载，这个接口防抖 */
  downloadReportCsv (id, debounce) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/reports/${id}`,
      debounce: true,
      debounceId: `GET:${legacyV2()}/reports/${id}`
    })
  },

  getReceipts (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/receipt`,
      params
    })
  },

  getConsolidatedReports () {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/taxijobs/actives`
    })
  },

  downloadConsolidatedReportById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/report/taxijobs/download/${id}`
    })
  }
}

export default report
